import React from 'react'

import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { UpsellSourceType, missingAddonUpsellRequestProps } from 'modules/finance/lib/upsellUtils'
import { UpsellingKit } from 'modules/upselling_kit/components'
import { useGetUpsellingData } from 'modules/upselling_kit/hooks/useGetUpsellingData'

interface UpsellModuleBannerProps {
  title: string
  content: string
  source: UpsellSourceType
  missingModule: AvailableModules
  missingFeature: Features
  onHide: () => void
}

export const UpsellModuleBanner = ({
  title,
  content,
  missingModule,
  missingFeature,
  onHide,
  source = 'ap_accounting_overview_upsell_card',
}: UpsellModuleBannerProps) => {
  const { moduleRequested, featureRequested, requestReason, requestSource } =
    missingAddonUpsellRequestProps(source, missingModule, missingFeature)
  const { upsellModalImage: defaultUpsellModalImage } = useGetUpsellingData({ moduleRequested })

  return (
    <UpsellingKit.ProductBanner
      moduleRequested={moduleRequested}
      featureRequested={featureRequested}
      requestSource={requestSource || ''}
      requestReason={requestReason}
      title={title}
      subtitle={content}
      mediaUrl={defaultUpsellModalImage || ''}
      onClose={onHide}
      primaryAction={{
        label: i18n.t('project_management.upselling.cta'),
        variant: 'default',
      }}
    />
  )
}
